// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/entity_file.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DeleteEntityFileRequest, DeleteEntityFileResponse, GetEntityFileDownloadUrlRequest, GetEntityFileDownloadUrlResponse, ListEntityFilesRequest, ListEntityFilesResponse, UploadEntityFileRequest, UploadEntityFileResponse } from "./entity_file_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.EntityFileService
 */
export const EntityFileService = {
  typeName: "omnios.v1.EntityFileService",
  methods: {
    /**
     * @generated from rpc omnios.v1.EntityFileService.ListEntityFiles
     */
    listEntityFiles: {
      name: "ListEntityFiles",
      I: ListEntityFilesRequest,
      O: ListEntityFilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EntityFileService.UploadEntityFile
     */
    uploadEntityFile: {
      name: "UploadEntityFile",
      I: UploadEntityFileRequest,
      O: UploadEntityFileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EntityFileService.DeleteEntityFile
     */
    deleteEntityFile: {
      name: "DeleteEntityFile",
      I: DeleteEntityFileRequest,
      O: DeleteEntityFileResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.EntityFileService.GetEntityFileDownloadUrl
     */
    getEntityFileDownloadUrl: {
      name: "GetEntityFileDownloadUrl",
      I: GetEntityFileDownloadUrlRequest,
      O: GetEntityFileDownloadUrlResponse,
      kind: MethodKind.Unary,
    },
  }
};

